import Api from "@/repository/api";
import qs from "qs";
import { PaginationRequestType } from "@/entity/common/pagination.types";
import { ResponseDataType } from "@/form/form.types";
import { IServicesCategoryRepository } from "@/repository/servicesCategory/ServicesCategoryRepository.types";
import { IServicesCategory, IServicesCategoryListItem, ServicesCategoryResponseType } from "@/entity/servicesCategory/services.category.types";
import ServicesCategory from "@/entity/servicesCategory/services.category";
import { ServiceCategoryCreateRequestType } from "@/form/serviceCategory/serviceCategoryCreate.types";

export class ServiceCategoryRepository implements IServicesCategoryRepository{

    Category_Url(mode?:boolean):string {
        return (!mode)? '/service_category/get':'/service_category/nomenclature/get'
    }

    async fetchAll(data?: FormData, mode?:boolean): Promise<IServicesCategory>{
        const response = await Api.get(this.Category_Url(mode), {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString()
        }});
        const responseData = response.data as ServicesCategoryResponseType;
        return new ServicesCategory(responseData);
    }

    async fetchData(data: PaginationRequestType, mode?:boolean): Promise<IServicesCategoryListItem> {
        const response = await Api.get(this.Category_Url(mode), {
            params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        const responseData = response.data as ServicesCategoryResponseType;
        return new ServicesCategory(responseData).data[0];
    }

    async create(data: ServiceCategoryCreateRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/service_category/create`, data);
        const responseData = response.data;
        return responseData;
    }
    async update(data: ServiceCategoryCreateRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/service_category/update`, data);
        const responseData = response.data;
        return responseData;
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/service_category/delete`, data);
        const responseData = response.data;
        return responseData;
    }
}